import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { LinkIcon } from 'foundations-assets/icons/components/LinkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AVATAR_COLORS = ['fill-accent-orange-default', 'fill-accent-teal-default', 'fill-accent-purple-default', 'fill-accent-magenta-default', 'fill-accent-blue-default', 'fill-accent-green-default'];
function getAvatarColor(index) {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
}
const DUMMY_TEAM_MEMBERS = [{
  id: '1',
  name: 'SpongeBob SquarePants',
  email: 'spongebob@hubspot.com',
  role: 'Owner',
  avatarInitials: 'SS',
  avatarColor: getAvatarColor(0)
}, {
  id: '2',
  name: 'Patrick Star',
  email: 'patrick.star@hubspot.com',
  role: 'Editor',
  avatarInitials: 'PS',
  avatarColor: getAvatarColor(1)
}, {
  id: '3',
  name: 'Squidward Tentacles',
  email: 'squidward@hubspot.com',
  role: 'Viewer',
  avatarInitials: 'ST',
  avatarColor: getAvatarColor(2)
}, {
  id: '4',
  name: 'Sandy Cheeks',
  email: 'sandy.cheeks@hubspot.com',
  role: 'Editor',
  avatarInitials: 'SC',
  avatarColor: getAvatarColor(3)
}];
function Avatar({
  initials,
  color
}) {
  return /*#__PURE__*/_jsx(Flex, {
    backgroundColor: color,
    borderRadius: "full",
    inlineSize: "40px",
    blockSize: "40px",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-inverse-default",
      children: initials
    })
  });
}
export function ShareModal({
  open,
  onClose
}) {
  const [emailInput, setEmailInput] = useState('');
  const [teamMembers, setTeamMembers] = useState(DUMMY_TEAM_MEMBERS);
  const handleInvite = () => {
    if (!emailInput.trim()) return;
    const newMember = {
      id: String(Date.now()),
      name: emailInput.split('@')[0],
      email: emailInput,
      role: 'Viewer',
      avatarInitials: emailInput.substring(0, 2).toUpperCase(),
      avatarColor: getAvatarColor(teamMembers.length)
    };
    setTeamMembers([...teamMembers, newMember]);
    setEmailInput('');
  };
  const handleRoleChange = (memberId, newRole) => {
    setTeamMembers(teamMembers.map(member => member.id === memberId ? Object.assign({}, member, {
      role: newRole
    }) : member));
  };
  const handleRemoveMember = memberId => {
    setTeamMembers(teamMembers.filter(member => member.id !== memberId));
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleInvite();
    }
  };
  if (!open) return null;
  return /*#__PURE__*/_jsxs(Modal, {
    width: 560,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.shareModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      maxBlockSize: "60vh",
      overflow: "auto",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "500",
        children: /*#__PURE__*/_jsx(TextInput, {
          placeholder: I18n.text('app.shareModal.inputPlaceholder'),
          value: emailInput,
          onChange: e => setEmailInput(e.target.value),
          onKeyDown: handleKeyDown
        })
      }), /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          typography: "heading-100",
          marginBlockEnd: "300",
          color: "text-core-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.shareModal.peopleWithAccess"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          rowGap: "100",
          children: teamMembers.map(member => /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            justifyContent: "space-between",
            paddingBlock: "200",
            children: [/*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              columnGap: "300",
              children: [/*#__PURE__*/_jsx(Avatar, {
                initials: member.avatarInitials,
                color: member.avatarColor
              }), /*#__PURE__*/_jsxs(View, {
                children: [/*#__PURE__*/_jsx(Text, {
                  typography: "body-100",
                  color: "text-core-default",
                  children: member.name
                }), /*#__PURE__*/_jsx(Text, {
                  typography: "detail-100",
                  color: "text-core-subtle",
                  children: member.email
                })]
              })]
            }), member.role === 'Owner' ? /*#__PURE__*/_jsx(Text, {
              typography: "body-100",
              color: "text-core-subtle",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.shareModal.roleOwner"
              })
            }) : /*#__PURE__*/_jsx(Dropdown, {
              buttonText: I18n.text(`app.shareModal.role${member.role}`),
              buttonUse: "transparent",
              menuWidth: 180,
              children: /*#__PURE__*/_jsxs(List, {
                children: [/*#__PURE__*/_jsx(ListItem, {
                  children: /*#__PURE__*/_jsx(Button, {
                    use: "transparent",
                    onClick: () => handleRoleChange(member.id, 'Editor'),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.shareModal.roleEditor"
                    })
                  })
                }), /*#__PURE__*/_jsx(ListItem, {
                  children: /*#__PURE__*/_jsx(Button, {
                    use: "transparent",
                    onClick: () => handleRoleChange(member.id, 'Viewer'),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.shareModal.roleViewer"
                    })
                  })
                }), /*#__PURE__*/_jsx(ListItem, {
                  children: /*#__PURE__*/_jsx(Button, {
                    use: "link-danger",
                    onClick: () => handleRemoveMember(member.id),
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.shareModal.removeAccess"
                    })
                  })
                })]
              })
            })]
          }, member.id))
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsxs(Button, {
          use: "tertiary-light",
          onClick: onClose,
          children: [/*#__PURE__*/_jsx(LinkIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.shareModal.copyLink"
          })]
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.shareModal.done"
          })
        })]
      })
    })]
  });
}